const SerialPortCommunicationHandlerProvider = require("./Devices/SerialPortCommunicationHandlerProvider");
const WebSerialDisplayControl = require("./WebSerialDisplayControl");

const Logger = require("../Logger");

const SECONDS = 1000;
const POWER_STATUS_REQUEST_INTERVAL = 5 * SECONDS;

const service = {
  configured: false,
  requestInterval: null,
  serialPortCommunicationHandler: SerialPortCommunicationHandlerProvider.getSerialPortCommunicationHandler()
}

const performSerialConnectionSettingsValidation = () => {
  try {
    WebSerialDisplayControl.checkConnectionSettingsMatchHandlerExpectations( service.serialPortCommunicationHandler );

    return true;
  } catch( error ) {
    Logger.viewerWarning(
      `Display control connection settings do not match ${ service.serialPortCommunicationHandler.getType() } connection settings; screen status service won't be started`,
      { error: error && ( error.stack || error.message ) }
    );

    return false;
  }
}

const powerStatusListener = {
  onPowerStatus: powerStatus => {
    const update = { screenOff: !powerStatus };

    window.RiseVision.Viewer.Player.PlayerIntegration.notifyPowerStatusUpdate( update );
  },
  onError: error => {
    Logger.viewerError(
      "E999999999",
      "Error reading power status",
      { error: error && ( error.stack || error.message ) }
    );
  }
}

const configureSerialPortReader = () => {
  if( WebSerialDisplayControl.isSerialPortReaderConfigured() ) {
    console.log( "Serial port reader already configured, returning" );

    return Promise.resolve( true );
  }

  return WebSerialDisplayControl.configureSerialPortReader( service.serialPortCommunicationHandler )
  .then( () => true ) // no error occurred; so return true
  .catch( error => {
    Logger.viewerError(
      "E999999999",
      "Could not configure screen status service; not starting",
      { error: error && ( error.stack || error.message ) }
    );

    service.stop();

    return false;
  });
}

service.configure = () => {
  return Promise.resolve().then(() => {
    if( service.configured ) {
      Logger.viewerWarning(
        "Screen status service already configured; skipping configuration"
      );
  
      return false;
    }
  
    service.configured = performSerialConnectionSettingsValidation();
  
    if( !service.configured ) {
      return false;
    }
  
    return configureSerialPortReader().then( serialPortReaderConfigured => {
      if( !serialPortReaderConfigured ) {
        return false;
      }

      service.serialPortCommunicationHandler.addPowerStatusListener( powerStatusListener );
  
      return true;
    });
  });
}

service.start = ( setIntervalFunction = setInterval ) => {
  
  if( service.requestInterval ) {
    Logger.viewerWarning( "Screen status service already started" );

    return;
  }

  if( !service.configured ) {
    Logger.viewerError( "E999999999", "Screen status service not configured; can't start" );

    return;
  }

  service.requestInterval = setIntervalFunction( service.requestReadPowerStatus, POWER_STATUS_REQUEST_INTERVAL );
}

service.requestReadPowerStatus = () => {
  if( !service.configured ) {
    return Promise.resolve();
  }

  return Promise.resolve().then(() => {
    const command = service.serialPortCommunicationHandler.getPowerStatusCheckCommand();

    return WebSerialDisplayControl.sendCommand( command );
  }).catch( error => {
    Logger.viewerError(
      "E999999999",
      "Read power status execution error",
      { error: error && ( error.stack || error.message ) }
    );
  });
}

service.stop = () => {
  try {
    console.log( "Stopping web serial screen control service" );

    if( service.requestInterval ) {
      clearInterval( service.requestInterval );
      service.requestInterval = null;
    }

    service.serialPortCommunicationHandler.removePowerStatusListener( powerStatusListener );
  } catch( error ) {
    Logger.viewerError(
      "E999999999",
      "Error stopping screen status service",
      { error: error && ( error.stack || error.message ) }
    );
  } finally {
    service.configured = false;
  }
}

module.exports = service;
